module.exports = __webpack_public_path__ + "img/load_diagram.3c155965.png";